{
  "common": {
    "title": "Academy",
    "dateFormat": "yyyy-MM-dd",
    "dateTimeFormat": "yyyy-MM-dd HH:mm",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "open": "Open",
    "success": "Success!",
    "failure": "Failed"
  },
  "navigation": {
    "footer": {
      "contact": "Contact"
    },
    "navbar": {
      "welcome": "Welcome, {{ fullName }}"
    },
    "menu": {
      "dashboard": "Dashboard",
      "courses": "Courses",
      "instructions": "Instructions",
      "information": "Information",
      "settings": "Settings"
    }
  },
  "authentication": {
    "login": {
      "login": "Log in",
      "error": "Invalid Credentials",
      "forgot-password": "Forgot Password?"
    },
    "logout": {
      "logout": "Log out"
    },
    "forgot-password": {
      "forgot-password": "Forgot password?",
      "email": "Email",
      "forgot-password-hint": "We send you a link to reset your password by email.",
      "reset-password": "Reset password",
      "required": "Please enter your email address",
      "failure": "Failure, please try again later.."
    },
    "reset-password-hint": {
      "hint": "Please check your emails and follow the instructions provided in the email.\n\nPlease check your email in case you did not receive an email.\n\nIf you did not receive an email please contact: \nvanessa.wiesinger@sar-anlagenbau.at",
      "back": "Back"
    }
  },
  "instruction": {
    "instruction-page": {},
    "my-instructions": {
      "title": "Open Instructions"
    },
    "my-confirmed-instructions": {
      "title": "Confirmed Instructions"
    },
    "instruction-list": {
      "open": "Open"
    },
    "chapter-detail": {
      "confirm": "Confirm",
      "confirmation-dialog": {
        "content": "I confirm that I have read and understood the chapter.",
        "title": "Confirm chapter"
      },
      "download": "Download"
    },
    "instruction-detail": {
      "confirmed": "Confirmed at: ",
      "created": "Created: ",
      "deadline": "Deadline: "
    },
    "instruction-item": {
      "since": "Available since: ",
      "confirmed": "Confirmed at: ",
      "deadline": "Deadline: "
    }
  },
  "instruction-details": {
    "quizz-question": {
      "one-or-more-hint": "* Pick one or more answers."
    },
    "chapter-quizz": {
      "check-answers": "Check answers",
      "success": "Chapter confirmed!",
      "error": "Your answer was incorrect! - Try Again"
    },
    "chapters": {
      "confirmed": "Chapter confirmed",
      "not-confirmed": " Chapter not confirmed",
      "open-chapter": "Open chapter",
      "confirm-chapter": "Confirm chapter",
      "confirmed-percentage": "{{ percentage }}% finished",
      "confirmed-chapters": "Confirmed {{ confirmedChapters }}/{{chapters}}"
    }
  },
  "dashboard": {
    "dashboard": {
      "active-courses": "Open Courses",
      "finished-courses": "Confirmed Courses",
      "open-instructions": "Open Instructions",
      "finished-instructions": "Confirmed Instructions",
      "progress": "Progress",
      "information": "Unread Information"
    }
  },
  "settings": {
    "change-password": {
      "title": "Change password",
      "min-length": "The password is too short",
      "required": "Required",
      "old-password": "Current password",
      "new-password": "New password",
      "new-password-check": "Confirm new password",
      "password-mismatch": "The passwords do not match",
      "password-complexity": {
        "error": "The password complexity must be at least:",
        "length": "- {{ length }} Length",
        "required-capital-letters": "- {{ requiredCapitalLetters }} capital letters",
        "required-small-letters": "- {{ requiredSmallLetters }} letters",
        "required-numbers": "- {{ requiredNumbers }} numbers",
        "required-symbols": "- {{ requiredSymbols }} symbols"
      },
      "failure": "Error settings the password",
      "success": "Password changed",
      "logout-hint": "By changing the password you must login again"
    },
    "change-language": {
      "title": "Language",
      "change-language": "Choose Language"
    }
  }
}
